module.exports = __webpack_public_path__ + "assets/b41.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b41.png
// module id = 629
// module chunks = 0